module.exports = __webpack_public_path__ + "static/media/edsider3.b09d754b.svg";